import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  selectedStatus: null,
  searchText: null,
  empresa: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  grupo: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
